import buildURL from "axios/lib/helpers/buildURL";

const axios = window.axios;

const dispatcherUrl = "/api/dispatcher";

export let Forms = {
  list() {
    const params = {
      controller: "forms",
      task: "list",
    };

    return axios
      .get(dispatcherUrl, { params, cache: { ignoreCache: true } })
      .then((response) => response.data);
  },
  structure(formname, hidden, filter, context) {
    const params = {
      controller: "forms",
      task: "getformstructure",
      formname,
    };

    if (hidden) {
      params.hidden = hidden;
    }

    if (filter) {
      params.filter = filter;
    }

    if (context) {
      params.params = context;
    }

    let promise = null;

    if (hidden || filter || context) {
      promise = axios.post(dispatcherUrl, params, {
        responseType: "arraybuffer",
      });
    } else {
      promise = axios.get(dispatcherUrl, { params });
    }

    return promise.then((response) => {
      console.log(response);
      return {
        contentType: response.headers["content-type"].split(";")[0],
        data: response.data,
      };
    });
  },
  data(formname, filter, context) {
    const params = {
      controller: "forms",
      task: "getformdata",
      formname,
    };

    let promise = null;

    if (filter && Object.keys(filter).length) {
      params.filter = Object.keys(filter).reduce((acc, key) => {
        if (filter[key] != undefined) {
          acc[key] = filter[key];
        }
        return acc;
      }, {});
    }

    if (context) {
      params.params = context;
    }

    promise = axios.post(dispatcherUrl, params);

    return promise.then((response) => response.data);
  },
  save(formname, data, context) {
    const params = {
      controller: "forms",
      task: "saveformvalues",
      formname,
      data,
    };

    if (context) {
      params.params = context;
    }

    params.method = data.nmbr ? "update" : "insert";
    return axios.post(dispatcherUrl, params).then((response) => response.data);
  },
  delete(formname, data) {
    const params = {
      controller: "forms",
      task: "saveformvalues",
      method: "delete",
      formname,
      data,
    };

    return axios.post(dispatcherUrl, params).then((response) => response.data);
  },
  can_change_data(formname, data, method) {
    const params = {
      controller: "forms",
      task: "can_change_data",
      formname,
      data,
      method,
    };

    return axios.post(dispatcherUrl, params).then((response) => response.data);
  },
  menu() {
    const params = {
      controller: "forms",
      task: "getmainmenu",
    };

    return axios
      .get(dispatcherUrl, { params })
      .then((response) => response.data.arr_menu);
  },
  api_call(apiname, caller, filter, context, add_params) {
    const params = {
      controller: "forms",
      task: "exe_api",
      apiname,
      caller,
      ...add_params,
    };

    if (filter) {
      params.filter = filter;
    }

    if (context) {
      params.params = context;
    }

    if (filter && filter.files) {
      let formData = new FormData();
      formData.append("params", JSON.stringify(params));
      for (let f of filter.files) {
        formData.append("files", f, f.name);
      }

      return axios
        .post(dispatcherUrl, formData)
        .then((response) => response.data);
    }

    return axios.post(dispatcherUrl, params).then((response) => response.data);
  },
  get_help(help_id) {
    const params = {
      controller: "forms",
      task: "gethelp",
      help_id,
    };
    return axios
      .get("/api/dispatcher", { params })
      .then((response) => response.data);
  },
  get_terr_svg_polygon(points) {
    const params = {
      controller: "forms",
      task: "get_terr_svg_polygon",
      geo_poly: points,
    };

    return axios
      .post("/api/dispatcher", params)
      .then((response) => response.data);
  },
  choice(formname, fieldname, choice_func, inputtext, caller_data) {
    const params = {
      controller: "forms",
      task: choice_func,
      formname,
      fieldname,
      inputtext,
      caller_data,
    };

    return axios.post(dispatcherUrl, params).then((response) => response.data);
  },
};

export function voip_login(call_id) {
  if (call_id) {
    const params = {
      call_id,
    };

    return axios
      .get("https://ru-tel.com/c/callframe/v2/auth.php", { params })
      .then((response) => {
        return response.data;
      });
  }

  const params = {
    controller: "account",
    task: "get_voip_login",
  };

  return axios.get("/api/common", { params }).then((response) => {
    return response.data;
  });
}

export let Orders = {
  pending() {
    const params = {
      controller: "order",
      task: "get_waiting_demands",
    };

    return axios
      .get(dispatcherUrl, { params })
      .then((response) => response.data);
  },
};

export let Search = {
  address(query) {
    const params = {
      query,
    };
    return axios
      .get("/api/org/suggest_address", { params })
      .then((response) => response.data);
  },
};

export let Files = {
  get(id) {
    const params = {
      controller: "forms",
      task: "getfile",
      id,
    };
    return axios.get(dispatcherUrl, { params }).then((response) => {
      return response.data;
    });
  },
  url(id) {
    const params = {
      controller: "forms",
      task: "getfile",
      id,
    };

    return buildURL(dispatcherUrl, params);
  },
};
